/*
  Aperte — filtrarea galeriei pe varianta selectata.

  Randarea initiala e facuta in Liquid (snippets/aperte-variant-media.liquid), ca sa
  nu palpaie. Scriptul asta se ocupa doar de:
    - lightbox (modalul nu e filtrat in Liquid, fiind ascuns pana la click)
    - schimbarea variantei fara reincarcare
  Harta variante/media vine din window.aperteVariantMedia[sectionId].
*/

(function () {
  var HIDDEN = 'aperte-media-hidden';

  function getConfig(sectionId) {
    return (window.aperteVariantMedia || {})[sectionId];
  }

  function toggle(root, selector, hide) {
    if (!root) return;
    root.querySelectorAll(selector).forEach(function (el) {
      el.classList.toggle(HIDDEN, hide);
    });
  }

  function apply(sectionId, code) {
    var cfg = getConfig(sectionId);
    if (!cfg || !cfg.media) return;

    var gallery = document.getElementById('MediaGallery-' + sectionId);
    var modal = document.getElementById('ProductModal-' + sectionId);

    Object.keys(cfg.media).forEach(function (mediaId) {
      var hide = cfg.media[mediaId] !== code;

      // Galerie: imaginea mare si thumbnail-ul corespunzator.
      toggle(gallery, '[data-media-id="' + sectionId + '-' + mediaId + '"]', hide);
      toggle(gallery, '[data-target="' + sectionId + '-' + mediaId + '"]', hide);

      // Lightbox: imaginea si thumbnail-ul folosesc id-ul brut, fara prefix.
      toggle(modal, '[data-media-id="' + mediaId + '"]', hide);
    });

    if (!gallery) return;

    // Daca imaginea activa tocmai a fost ascunsa, sari la prima vizibila.
    var active = gallery.querySelector('.product__media-item.is-active');
    if (!active || active.classList.contains(HIDDEN)) {
      var first = gallery.querySelector('.product__media-item:not(.' + HIDDEN + ')');
      if (first && first.dataset.mediaId && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(first.dataset.mediaId, false);
      }
    }

    // Recalculeaza paginile si contorul "1 / N" (initPages ignora elementele ascunse).
    gallery.querySelectorAll('slider-component').forEach(function (slider) {
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });
  }

  function init() {
    var all = window.aperteVariantMedia || {};
    Object.keys(all).forEach(function (sectionId) {
      apply(sectionId, all[sectionId].current);
    });

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = (event && event.data) || {};
      var variant = data.variant;
      var sectionId = data.sectionId;
      if (!variant || !sectionId) return;

      var cfg = getConfig(sectionId);
      if (!cfg || !cfg.variants) return;

      var code = cfg.variants[String(variant.id)];
      if (!code) return;

      cfg.current = code;
      apply(sectionId, code);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
